// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1x3R5","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3zpgZ"};